









































import { mapGetters, mapActions } from "vuex";
import { General } from "@/utils/constants";
import CircleLoading from "@/components/CircleLoading";
import { IObjectFileToUpload } from "@/store/types/file-type";
import { SnackQueue as Queue } from "@/plugins/SnackQueue";

export default {
  name: "ListUploadFiles",
  components: {
    CircleLoading
  },
  data() {
    return {
      General
    };
  },

  computed: {
    ...mapGetters({
      getListUploadFiles: "getListUploadFiles"
    }),

    showCancelButton() {
      return this.getListUploadFiles.some(
        (file: IObjectFileToUpload) => !file.isErro && file.status === "pending"
      );
    }
  },

  watch: {
    getListUploadFiles: {
      handler(listUploadFiles) {
        const countFiles = listUploadFiles.filter(
          (file: IObjectFileToUpload) => file.status === "pending"
        ).length;
        let newTitle = this.General.TEXTS.UPLOAD_FINISHED;
        if (countFiles) {
          const mensage =
            countFiles === 1
              ? this.General.TEXTS.UPLOAD_QUANTITY_SINGULAR
              : this.General.TEXTS.UPLOAD_QUANTITY;
          newTitle = mensage.replace("(QUANTITY)", countFiles);
        } else {
          Queue.open({
            id: "upload_files",
            canClose: true
          });
        }
        this.$emit("updateTitle", newTitle);
      },
      deep: true
    }
  },

  methods: {
    ...mapActions({
      setCancelUploadFile: "setCancelUploadFile"
    }),

    uploadCancel(fileIndex = -1) {
      this.setCancelUploadFile(fileIndex);
    }
  }
};
